import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'fav-tournaments',
  templateUrl: '../sharedTemplates/fav-tournaments.component.html',
})
export class FavTournamentsComponent implements OnInit, OnDestroy {
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  isOpenLeagueMenu = true;

  constructor(private _uiHelper: UiHelper, private _DataHelper: DataHelper, private _changeDetection: ChangeDetectorRef) {}

  favTournaments = [];
  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._uiHelper.favTournamentListener.subscribe(s => {
        this.favTournaments = s;
        this._changeDetection.detectChanges();
      })
    );
    this.favTournaments = this._uiHelper.favTournaments;
  }

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }
  selectedLeagueData = [];
  mainData = [];
  _dayFilter = 300;

  openLeague(tournament) {
    this.selectedLeagueData = [];

    const data = {
      TournamentName: tournament.tourname,
      TournamentId: tournament.tourid,
      CategoryId: tournament.catid,
      CategoryName: tournament.catname,
      SportId: 1,
      SportName: '',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
